/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type PdpSharedPurchaseButton_item = {
    readonly isPrivateVisibilityType: boolean | null;
    readonly hasPrivateListing: boolean | null;
    readonly serviceId: string | null;
    readonly pdpTrackingVpvParams?: unknown | null;
    readonly contemporaryTrackingString: string;
    readonly title: string | null;
    readonly vertical: VerticalType | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly pricing: {
        readonly totalAmount: {
            readonly amount: number | null;
        } | null;
    } | null;
    readonly categoryCode: string | null;
    readonly browseUrl: string | null;
    readonly " $refType": "PdpSharedPurchaseButton_item";
};
export type PdpSharedPurchaseButton_item$data = PdpSharedPurchaseButton_item;
export type PdpSharedPurchaseButton_item$key = {
    readonly " $data"?: PdpSharedPurchaseButton_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedPurchaseButton_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PdpSharedPurchaseButton_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isPrivateVisibilityType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasPrivateListing",
      "args": null,
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contemporaryTrackingString",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vertical",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPricing",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "totalAmount",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "amount",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "categoryCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "browseUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "pdpTrackingVpvParams",
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'e30dbb8ee2b83aa20fe4ec247f4e69d7';
export default node;
